module.exports = __webpack_public_path__ + "static/img/glyphicons-halflings-regular.8988968.svg";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 1056
// module chunks = 5